// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.order-page { min-height: 100vh; display: flex; flex-direction: column; }

.order-header {
  background: linear-gradient(135deg, #0f172a, #1e3a8a);
  color: var(--white);
  padding: 40px 0 36px;
}
.back-link {
  display: inline-block;
  color: #93c5fd;
  font-size: .875rem;
  margin-bottom: 12px;
  text-decoration: none;
}
.back-link:hover { color: var(--white); }
.order-header h1 { font-size: 1.8rem; font-weight: 800; margin-bottom: 6px; }
.order-header p { color: #94a3b8; }

.order-content {
  flex: 1 1;
  padding: 48px 24px 64px;
}

.order-form {
  max-width: 800px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 40px;
}

.order-section h2 {
  font-size: 1.1rem;
  font-weight: 700;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 2px solid var(--border);
}

/* ── Plan selector ── */
.plan-selector {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
}

.plan-option {
  position: relative;
  cursor: pointer;
}
.plan-option input { display: none; }

.plan-option-body {
  border: 2px solid var(--border);
  border-radius: var(--radius);
  padding: 24px;
  transition: border-color .2s, box-shadow .2s;
}
.plan-option.selected .plan-option-body {
  border-color: var(--primary);
  box-shadow: 0 0 0 4px rgba(37,99,235,.1);
}
.plan-option.popular .plan-option-body {
  border-color: var(--accent);
}
.plan-option.popular.selected .plan-option-body {
  border-color: var(--accent);
  box-shadow: 0 0 0 4px rgba(245,158,11,.12);
}

.popular-tag {
  display: inline-block;
  background: var(--accent);
  color: var(--white);
  font-size: .75rem;
  font-weight: 700;
  padding: 3px 10px;
  border-radius: 50px;
  margin-bottom: 12px;
}

.plan-name { font-size: 1rem; font-weight: 700; margin-bottom: 6px; }
.plan-price { font-size: 1.5rem; font-weight: 800; color: var(--text); margin-bottom: 4px; }
.plan-sub { font-size: .8rem; color: var(--success); font-weight: 600; margin-bottom: 16px; }

.plan-feats { list-style: none; font-size: .875rem; color: var(--text-muted); }
.plan-feats li { padding: 4px 0; }

.form-hint {
  font-size: .8rem;
  color: var(--text-muted);
  margin-top: 6px;
}

/* ── Summary ── */
.summary-box {
  background: var(--surface);
  border: 1.5px solid var(--border);
  border-radius: var(--radius-sm);
  margin-bottom: 24px;
  overflow: hidden;
}

.summary-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 20px;
  border-bottom: 1px solid var(--border);
  font-size: .9rem;
}
.summary-row:last-child { border-bottom: none; }
.summary-row span { color: var(--text-muted); }
.summary-total { background: var(--primary-light); }
.summary-total span, .summary-total strong { color: var(--primary); font-size: 1.05rem; }

.payment-info {
  background: #fffbeb;
  border: 1px solid #fde68a;
  border-radius: var(--radius-sm);
  padding: 16px 20px;
  margin-bottom: 20px;
  font-size: .875rem;
  color: #78350f;
}
.payment-info h4 { margin-bottom: 6px; font-size: .9rem; }

.order-note {
  text-align: center;
  font-size: .78rem;
  color: var(--text-muted);
  margin-top: 12px;
}

/* ── Success ── */
.order-success {
  max-width: 700px;
  margin: 0 auto;
  padding: 64px 0;
  text-align: center;
}
.success-icon { font-size: 4rem; margin-bottom: 24px; }
.order-success h1 { font-size: 2rem; font-weight: 800; margin-bottom: 12px; }
.order-success > p { color: var(--text-muted); margin-bottom: 40px; }

.cheque-instructions {
  background: var(--white);
  border: 2px solid var(--primary);
  border-radius: var(--radius);
  padding: 32px;
  text-align: left;
  margin-bottom: 40px;
  box-shadow: var(--shadow-lg);
}
.cheque-instructions h2 { font-size: 1.15rem; font-weight: 700; margin-bottom: 20px; }

.instruction-steps {}
.instruction-row {
  display: flex;
  align-items: baseline;
  gap: 16px;
  padding: 12px 0;
  border-bottom: 1px solid var(--border);
  font-size: .9rem;
}
.instruction-row:last-child { border: none; }
.instr-label { min-width: 180px; color: var(--text-muted); font-size: .85rem; }
.instruction-row code { background: var(--surface); padding: 3px 8px; border-radius: 4px; font-size: .875rem; }

.success-actions {
  display: flex;
  gap: 16px;
  justify-content: center;
  flex-wrap: wrap;
}

@media (max-width: 640px) {
  .plan-selector { grid-template-columns: 1fr; }
  .instruction-row { flex-direction: column; gap: 4px; }
  .instr-label { min-width: unset; }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Order.css"],"names":[],"mappings":"AAAA,cAAc,iBAAiB,EAAE,aAAa,EAAE,sBAAsB,EAAE;;AAExE;EACE,qDAAqD;EACrD,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,qBAAqB;EACrB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;AACvB;AACA,mBAAmB,mBAAmB,EAAE;AACxC,mBAAmB,iBAAiB,EAAE,gBAAgB,EAAE,kBAAkB,EAAE;AAC5E,kBAAkB,cAAc,EAAE;;AAElC;EACE,SAAO;EACP,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,sCAAsC;AACxC;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;AACA,qBAAqB,aAAa,EAAE;;AAEpC;EACE,+BAA+B;EAC/B,4BAA4B;EAC5B,aAAa;EACb,4CAA4C;AAC9C;AACA;EACE,4BAA4B;EAC5B,wCAAwC;AAC1C;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,aAAa,eAAe,EAAE,gBAAgB,EAAE,kBAAkB,EAAE;AACpE,cAAc,iBAAiB,EAAE,gBAAgB,EAAE,kBAAkB,EAAE,kBAAkB,EAAE;AAC3F,YAAY,gBAAgB,EAAE,qBAAqB,EAAE,gBAAgB,EAAE,mBAAmB,EAAE;;AAE5F,cAAc,gBAAgB,EAAE,kBAAkB,EAAE,wBAAwB,EAAE;AAC9E,iBAAiB,cAAc,EAAE;;AAEjC;EACE,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE,0BAA0B;EAC1B,iCAAiC;EACjC,+BAA+B;EAC/B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,sCAAsC;EACtC,gBAAgB;AAClB;AACA,0BAA0B,mBAAmB,EAAE;AAC/C,oBAAoB,wBAAwB,EAAE;AAC9C,iBAAiB,gCAAgC,EAAE;AACnD,6CAA6C,qBAAqB,EAAE,kBAAkB,EAAE;;AAExF;EACE,mBAAmB;EACnB,yBAAyB;EACzB,+BAA+B;EAC/B,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;AACA,mBAAmB,kBAAkB,EAAE,gBAAgB,EAAE;;AAEzD;EACE,kBAAkB;EAClB,iBAAiB;EACjB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;AACA,gBAAgB,eAAe,EAAE,mBAAmB,EAAE;AACtD,oBAAoB,eAAe,EAAE,gBAAgB,EAAE,mBAAmB,EAAE;AAC5E,qBAAqB,wBAAwB,EAAE,mBAAmB,EAAE;;AAEpE;EACE,wBAAwB;EACxB,gCAAgC;EAChC,4BAA4B;EAC5B,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,4BAA4B;AAC9B;AACA,0BAA0B,kBAAkB,EAAE,gBAAgB,EAAE,mBAAmB,EAAE;;AAErF,oBAAoB;AACpB;EACE,aAAa;EACb,qBAAqB;EACrB,SAAS;EACT,eAAe;EACf,sCAAsC;EACtC,gBAAgB;AAClB;AACA,8BAA8B,YAAY,EAAE;AAC5C,eAAe,gBAAgB,EAAE,wBAAwB,EAAE,iBAAiB,EAAE;AAC9E,wBAAwB,0BAA0B,EAAE,gBAAgB,EAAE,kBAAkB,EAAE,kBAAkB,EAAE;;AAE9G;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,iBAAiB,0BAA0B,EAAE;EAC7C,mBAAmB,sBAAsB,EAAE,QAAQ,EAAE;EACrD,eAAe,gBAAgB,EAAE;AACnC","sourcesContent":[".order-page { min-height: 100vh; display: flex; flex-direction: column; }\n\n.order-header {\n  background: linear-gradient(135deg, #0f172a, #1e3a8a);\n  color: var(--white);\n  padding: 40px 0 36px;\n}\n.back-link {\n  display: inline-block;\n  color: #93c5fd;\n  font-size: .875rem;\n  margin-bottom: 12px;\n  text-decoration: none;\n}\n.back-link:hover { color: var(--white); }\n.order-header h1 { font-size: 1.8rem; font-weight: 800; margin-bottom: 6px; }\n.order-header p { color: #94a3b8; }\n\n.order-content {\n  flex: 1;\n  padding: 48px 24px 64px;\n}\n\n.order-form {\n  max-width: 800px;\n  margin: 0 auto;\n  display: flex;\n  flex-direction: column;\n  gap: 40px;\n}\n\n.order-section h2 {\n  font-size: 1.1rem;\n  font-weight: 700;\n  margin-bottom: 20px;\n  padding-bottom: 10px;\n  border-bottom: 2px solid var(--border);\n}\n\n/* ── Plan selector ── */\n.plan-selector {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 20px;\n}\n\n.plan-option {\n  position: relative;\n  cursor: pointer;\n}\n.plan-option input { display: none; }\n\n.plan-option-body {\n  border: 2px solid var(--border);\n  border-radius: var(--radius);\n  padding: 24px;\n  transition: border-color .2s, box-shadow .2s;\n}\n.plan-option.selected .plan-option-body {\n  border-color: var(--primary);\n  box-shadow: 0 0 0 4px rgba(37,99,235,.1);\n}\n.plan-option.popular .plan-option-body {\n  border-color: var(--accent);\n}\n.plan-option.popular.selected .plan-option-body {\n  border-color: var(--accent);\n  box-shadow: 0 0 0 4px rgba(245,158,11,.12);\n}\n\n.popular-tag {\n  display: inline-block;\n  background: var(--accent);\n  color: var(--white);\n  font-size: .75rem;\n  font-weight: 700;\n  padding: 3px 10px;\n  border-radius: 50px;\n  margin-bottom: 12px;\n}\n\n.plan-name { font-size: 1rem; font-weight: 700; margin-bottom: 6px; }\n.plan-price { font-size: 1.5rem; font-weight: 800; color: var(--text); margin-bottom: 4px; }\n.plan-sub { font-size: .8rem; color: var(--success); font-weight: 600; margin-bottom: 16px; }\n\n.plan-feats { list-style: none; font-size: .875rem; color: var(--text-muted); }\n.plan-feats li { padding: 4px 0; }\n\n.form-hint {\n  font-size: .8rem;\n  color: var(--text-muted);\n  margin-top: 6px;\n}\n\n/* ── Summary ── */\n.summary-box {\n  background: var(--surface);\n  border: 1.5px solid var(--border);\n  border-radius: var(--radius-sm);\n  margin-bottom: 24px;\n  overflow: hidden;\n}\n\n.summary-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 12px 20px;\n  border-bottom: 1px solid var(--border);\n  font-size: .9rem;\n}\n.summary-row:last-child { border-bottom: none; }\n.summary-row span { color: var(--text-muted); }\n.summary-total { background: var(--primary-light); }\n.summary-total span, .summary-total strong { color: var(--primary); font-size: 1.05rem; }\n\n.payment-info {\n  background: #fffbeb;\n  border: 1px solid #fde68a;\n  border-radius: var(--radius-sm);\n  padding: 16px 20px;\n  margin-bottom: 20px;\n  font-size: .875rem;\n  color: #78350f;\n}\n.payment-info h4 { margin-bottom: 6px; font-size: .9rem; }\n\n.order-note {\n  text-align: center;\n  font-size: .78rem;\n  color: var(--text-muted);\n  margin-top: 12px;\n}\n\n/* ── Success ── */\n.order-success {\n  max-width: 700px;\n  margin: 0 auto;\n  padding: 64px 0;\n  text-align: center;\n}\n.success-icon { font-size: 4rem; margin-bottom: 24px; }\n.order-success h1 { font-size: 2rem; font-weight: 800; margin-bottom: 12px; }\n.order-success > p { color: var(--text-muted); margin-bottom: 40px; }\n\n.cheque-instructions {\n  background: var(--white);\n  border: 2px solid var(--primary);\n  border-radius: var(--radius);\n  padding: 32px;\n  text-align: left;\n  margin-bottom: 40px;\n  box-shadow: var(--shadow-lg);\n}\n.cheque-instructions h2 { font-size: 1.15rem; font-weight: 700; margin-bottom: 20px; }\n\n.instruction-steps {}\n.instruction-row {\n  display: flex;\n  align-items: baseline;\n  gap: 16px;\n  padding: 12px 0;\n  border-bottom: 1px solid var(--border);\n  font-size: .9rem;\n}\n.instruction-row:last-child { border: none; }\n.instr-label { min-width: 180px; color: var(--text-muted); font-size: .85rem; }\n.instruction-row code { background: var(--surface); padding: 3px 8px; border-radius: 4px; font-size: .875rem; }\n\n.success-actions {\n  display: flex;\n  gap: 16px;\n  justify-content: center;\n  flex-wrap: wrap;\n}\n\n@media (max-width: 640px) {\n  .plan-selector { grid-template-columns: 1fr; }\n  .instruction-row { flex-direction: column; gap: 4px; }\n  .instr-label { min-width: unset; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
